import { Divider, Grid, Table, TableBody, TableContainer, TableHead } from "@mui/material";
import React, { useEffect, useState } from "react";
import { CiCircleQuestion } from "react-icons/ci";
import { toast } from "react-toastify";
import { DarkGreenColorButton, GreenColorButton, PrimeGrayBorderColorButton, RedColorButton } from "../../../Components/MaterialButtonStyle/StyleButton";
import { StyledTableCell, StyledTableRow } from "../../../Components/MaterialTableStyle/MaterialTableStyle";
import CustomCheckBox from "../../../Components/CheckBox/CustomCheckBox";
import TextAreaField from "../../../Components/CustomInputs/TextArea";
import RightSideModal from "../../../Components/Modal/RightSideModal";
import CustomInput from "../../../Components/CustomInputs/CustomInputs";
import DatePicker from "../../../Components/DateRangeSelector/DatePicker";
import CustomTimePicker from "../../../Components/DateRangeSelector/CustomTimePicker";
import CustomModal from "../../../Components/Modal/CustomModal";

import {  convertTo12Hour } from "../../../Components/Helpers/DateTimeConverter";
import { GetPublicURL } from "../../../Helper/api";
const FinalAppointmentDetails = ({ OpenAppointmentCopy, appointmentOfferLetter, setAppointmentOfferLetter, CloseAppointmentOfferModal, offerLetterCheckBoxData, setOfferLetterCheckBoxData, applicationDetail, primaryDuties, setPrimaryDuties, appointmentData, setAppointmentData, RejectModalOpen, isEdit,CandidateDetail }) => {
  const [confomationModal, setConfomationModal] = useState(false)
  const [applicant_image, setapplicant_image] = useState()
  const CloseConfomationModal = () => {
    setConfomationModal(false);
    setAppointmentOfferLetter(true);
  }
  const UpdateConformed = () => {
    setConfomationModal(false)
    setAppointmentOfferLetter(false);
  }

  const HandleApplicantDataValueChange = (value, row, timerange) => {
    const updatedPhysicalData = appointmentData.map((item) => {
      if (item.name === row.name) {
        if (row.type == "hour") {
          if (timerange == "to" && !item.from) {
            toast.error("Please Select Working Start Time");
            return item;
          }
          return { ...item, [timerange]: value };
        } else {
          return { ...item, value };
        }
      }
      return item;
    });
    setAppointmentData(updatedPhysicalData);
  }
  const HandleOfferCheckBoxChange = (value, name) => {
    setOfferLetterCheckBoxData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }
  const UpdateAppointmentOfferModal = () => {
    try {
      appointmentData.map((row) => {
        if (row.type == "hour") {
          if (!row?.from) {
            throw new Error("Please Select Working Starting Hours");
          }
          if (String(row?.from)?.trim().length === 0) {
            throw new Error("Please Select Working Starting Hours");
          }
          if (!row?.to) {
            throw new Error("Please Select Working Ending Hours");
          }
          if (String(row?.to)?.trim().length === 0) {
            throw new Error("Please Select Working Ending Hours");
          }
        } else {
          if (row?.value?.trim().length === 0) {
            throw new Error(`Please ${row.Placeholder}`);
          }
        }
      });
    } catch (err) {
      toast.error(err.message);
      return;
    }
    if (!primaryDuties) {
      toast.error("Please Enter Primary Duties");
      return
    }
    if (primaryDuties?.trim()?.length == 0) {
      toast.error("Please Enter Valid Primary Duties");
      return
    }
    if (!offerLetterCheckBoxData) {
      toast.error("Please ensure all criteria are selected before updating the final appointment details");
      return
    }
    if (!offerLetterCheckBoxData.candidatePersonalInfo) {
      toast.error("Please ensure all criteria are selected before updating the final appointment details");
      return
    }
    if (!offerLetterCheckBoxData.candidateRequirement) {
      toast.error("Please ensure all criteria are selected before updating the final appointment details");
      return
    }
    if (!offerLetterCheckBoxData.candidateApplicationStage) {
      toast.error("Please ensure all criteria are selected before updating the final appointment details");
      return
    }
    if (!offerLetterCheckBoxData.candidateAllDocument) {
      toast.error("Please ensure all criteria are selected before updating the final appointment details");
      return
    }
    if (!offerLetterCheckBoxData.candidateFinalAppointment) {
      toast.error("Please ensure all criteria are selected before updating the final appointment details");
      return
    }
    setAppointmentOfferLetter(false);
    setConfomationModal(true);
  }
  const DownloadAppointmentLetters =()=>{
    setAppointmentOfferLetter(false)
    OpenAppointmentCopy()
  }
  
  useEffect(()=>{
    if(applicationDetail.applicant_image){
      GetPublicURLS(applicationDetail.applicant_image)
    }
  },[applicationDetail])
  const GetPublicURLS =async(URL)=>{
    const Images =await GetPublicURL(URL)
    setapplicant_image(Images)
  }
  return (
    <Grid item >
      <RightSideModal
        open={appointmentOfferLetter}
        setOpen={CloseAppointmentOfferModal}
        width={"40%"}
        scroll={true}
        height={"90vh"}

        modalTitle={<h4 className="poppinsSemiBold Text-Prime-Black text-left">
          Final Appointment Details and Offer Letter
        </h4>}
        modalContent={
          <Grid item lg={12} md={12} sm={12} xs={12} className="px-2">
            <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2 " alignItems={"center"} justifyContent={"space-between"}>
              <Grid item lg={9} sm={9} md={9} xs={9} container alignItems={"center"}>
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Name of the Post Applying for
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.job_name ? applicationDetail?.job_name : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Notification Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.application_serial ? applicationDetail?.application_serial : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Application Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.application_serial ? applicationDetail?.application_serial : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Name
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {CandidateDetail?.Title ? CandidateDetail?.Title : ""}{CandidateDetail.Surname ? CandidateDetail.Surname : "--"} {CandidateDetail.LastName ? CandidateDetail.LastName : "--"}
                    </p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={2} sm={2} md={2} xs={2} container justifyContent={"flex-end"}>
                {applicant_image&& <img src={applicant_image} alt="PSCLogo" height={150} width={150} className="img_fluid" />}
              </Grid>
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2">
              <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"}>
                <h5 className="poppinsSemiBold Text-Prime-Black text-left">
                  Screening Results
                </h5>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} >
                <TableContainer className="mt-3">
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>Test Name</StyledTableCell>
                        <StyledTableCell>Outcome</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      <StyledTableRow >
                        <StyledTableCell align="left">
                          <p className="poppinsMedium Text-Prime-Black">Physical Screening Test</p>
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <p className="poppinsRegular Text-Prime-Black">Fit For this Role</p>
                        </StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow >
                        <StyledTableCell align="left">
                          <p className="poppinsMedium Text-Prime-Black">Certificate Verfication Remarks</p>
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <p className="poppinsRegular Text-Prime-Black">All certificates are Verified</p>
                        </StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow >
                        <StyledTableCell align="left">
                          <p className="poppinsMedium Text-Prime-Black">Marks Obtained in Computer Based Test</p>
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <p className="poppinsRegular Text-Prime-Black">90 out of 100</p>
                        </StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow >
                        <StyledTableCell align="left">
                          <p className="poppinsMedium Text-Prime-Black">Medically Assessment Test</p>
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <p className="poppinsRegular Text-Prime-Black">Medically Fit and Checkups Done</p>
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <Divider className="mt-1 w-100" sx={{ border: "1px solid #a7aba96e" }} />
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"} className="pt-3">
                <h5 className="poppinsSemiBold Text-Prime-Black text-left">
                  Other Informations
                </h5>
              </Grid>
              <Divider className="my-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
              <Grid item lg={12} sm={12} md={12} xs={12} className="pt-2" >
                <TableContainer >
                  <Table stickyHeader aria-label="sticky table">
                    <TableBody>
                      {appointmentData.map((row, i) => {
                        return (
                          <StyledTableRow key={i}>
                            <StyledTableCell align="left">
                              <p className="poppinsMedium Text-Prime-Black">{row.name}</p>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {row.type == "input" && isEdit &&
                                <CustomInput
                                  placeholder={row.Placeholder}
                                  backgroundColor="#FFFFFF"
                                  width={"100%"}
                                  maxLength={50}
                                  height={"45px"}
                                  padding={"2.5% 3% 2.5% 0%"}
                                  border={"1px solid #666666"}
                                  fontFamily={"PoppinsMedium"}
                                  value={row.value}
                                  onChange={(e) => HandleApplicantDataValueChange(e.target.value, row)}
                                />}
                              {row.type == "date" && isEdit &&
                                <DatePicker
                                  isPast={true}
                                  placeholder={row.Placeholder}
                                  height={"45px"}
                                  fontFamily={"PoppinsMedium"}
                                  Value={row.value}
                                  handleInput={(e) => HandleApplicantDataValueChange(e, row)}
                                />}
                              {row.type == "hour" && isEdit &&
                                <Grid item container justifyContent={"space-between"} alignItems={"center"}>
                                  <CustomTimePicker
                                    height={"45px"}
                                    width={"100%"}
                                    placeholder={row.Placeholder}
                                    handleInput={(e) => HandleApplicantDataValueChange(e, row, "from")}
                                  />
                                  <p className="poppinsMedium Text-Prime-Black">To</p>
                                  <CustomTimePicker
                                    height={"45px"}
                                    width={"100%"}
                                    placeholder={row.Placeholder}
                                    handleInput={(e) => HandleApplicantDataValueChange(e, row, "to")}
                                  />
                                </Grid>
                              }
                              <p className="poppinsRegular Text-Prime-Black text-left text-capitalize ">
                                {row.name=="Job Location"? applicationDetail?.job_location: row.name=="Job Start Date"?applicationDetail?.job_start_date:row.name=="Monthly Salary"?applicationDetail?.job_salary:row.name=="Probation Period"?applicationDetail?.job_probation:row.name=="Working Hours"?
                                  convertTo12Hour(applicationDetail?.working_hours) +" - "+ convertTo12Hour(applicationDetail?.working_hours_to):""}
                              </p>

                            </StyledTableCell>
                          </StyledTableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Divider className="mt-2 mb-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />
              <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" flexDirection={"column"}>
                <Grid item container >
                  <p className="poppinsMedium Text-Prime-Black text-left w-100">
                    Primary Duties
                  </p>
                </Grid>
                <Grid item className="py-2" container>
                  {isEdit ?
                    <TextAreaField
                      placeholder="Enter the Primary Duties"
                      fontSize={14}
                      backgroundColor="#FFFFFF"
                      width={"100%"}
                      maxLength={1000}
                      padding={"2.5% 3% 2.5% 0%"}
                      placeholderColor="#666666"
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      value={primaryDuties}
                      onChange={(e) => setPrimaryDuties(e.target.value)}
                    /> :
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.primary_duties? applicationDetail?.primary_duties:"---"}
                    </p>
                  }
                </Grid>
              </Grid>
              {localStorage.getItem("@userType") !== "applicant" &&
                <Divider className="mt-2 mb-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />
              }
              {localStorage.getItem("@userType") !== "applicant" &&
                <Grid item lg={12} sm={12} md={12} xs={12} container alignItems={"center"} flexDirection={"column"} className="py-2">
                  <Grid item container alignItems={"center"} flexDirection={"row"}>
                    <Grid item lg={1} md={1} sm={1} xs={1}>
                      <CustomCheckBox
                        disableColor={"transparent"}
                        checked={offerLetterCheckBoxData?.candidatePersonalInfo==true||!isEdit}
                        onChange={() => HandleOfferCheckBoxChange(!offerLetterCheckBoxData.candidatePersonalInfo, "candidatePersonalInfo")}
                      />
                    </Grid>
                    <Grid item lg={11} md={11} sm={11} xs={11}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        Confirm that the candidate’s personal information (name, application ID, role) has been verified and is accurate.
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item container alignItems={"center"} flexDirection={"row"}>
                    <Grid item lg={1} md={1} sm={1} xs={1}>
                      <CustomCheckBox
                        disableColor={"transparent"}
                        checked={offerLetterCheckBoxData?.candidateReview==true|| !isEdit}
                        onChange={() => isEdit&&HandleOfferCheckBoxChange(!offerLetterCheckBoxData.candidateReview, "candidateReview")}
                      />
                    </Grid>
                    <Grid item lg={11} md={11} sm={11} xs={11}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        Review and validate the results from both the physical and medical screening tests.
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item container alignItems={"center"} flexDirection={"row"}>
                    <Grid item lg={1} md={1} sm={1} xs={1}>
                      <CustomCheckBox
                        disableColor={"transparent"}
                        checked={offerLetterCheckBoxData?.candidateRequirement==true|| !isEdit}
                        onChange={() =>isEdit&& HandleOfferCheckBoxChange(!offerLetterCheckBoxData.candidateRequirement, "candidateRequirement")}
                      />
                    </Grid>
                    <Grid item lg={11} md={11} sm={11} xs={11}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        Ensure that the candidate meets all eligibility criteria, including educational qualifications, physical benchmarks, and background requirements.
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item container alignItems={"center"} flexDirection={"row"}>
                    <Grid item lg={1} md={1} sm={1} xs={1}>
                      <CustomCheckBox
                        disableColor={"transparent"}
                        checked={offerLetterCheckBoxData?.candidateApplicationStage==true||!isEdit}
                        onChange={() =>isEdit&& HandleOfferCheckBoxChange(!offerLetterCheckBoxData.candidateApplicationStage, "candidateApplicationStage")}
                      />
                    </Grid>
                    <Grid item lg={11} md={11} sm={11} xs={11}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        Verify that the candidate has successfully completed all application stages, including interviews, physical tests, and document submissions.
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item container alignItems={"center"} flexDirection={"row"}>
                    <Grid item lg={1} md={1} sm={1} xs={1}>
                      <CustomCheckBox
                        disableColor={"transparent"}
                        checked={offerLetterCheckBoxData?.candidateAllDocument==true|| !isEdit}
                        onChange={() => isEdit&&HandleOfferCheckBoxChange(!offerLetterCheckBoxData.candidateAllDocument, "candidateAllDocument")}
                      />
                    </Grid>
                    <Grid item lg={11} md={11} sm={11} xs={11}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        Confirm that all required documents (certificates, ID, etc.) have been verified, checked for authenticity, and are securely stored.
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item container alignItems={"flex-start"} flexDirection={"row"}>
                    <Grid item lg={1} md={1} sm={1} xs={1}>
                      <CustomCheckBox
                        disableColor={"transparent"}
                        checked={offerLetterCheckBoxData?.candidateFinalAppointment==true||!isEdit}
                        onChange={() => isEdit&&HandleOfferCheckBoxChange(!offerLetterCheckBoxData.candidateFinalAppointment, "candidateFinalAppointment")}
                      />
                    </Grid>
                    <Grid item lg={11} md={11} sm={11} xs={11}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        Confirm that the final appointment notification details (date, time, location) are ready to be communicated to the candidate.
                      </p>
                    </Grid>
                  </Grid>
                </Grid>}
            </Grid>
          </Grid>
        }
        modalFooter={
          isEdit ? <Grid item lg={12} md={12} sm={12} xs={12} container justifyContent={"flex-end"}>
            <RedColorButton
              type="submit"
              className="px-3 py-2"
              onClick={() => RejectModalOpen()}
            >
              Reject
            </RedColorButton>
            <GreenColorButton
              type="submit"
              className="px-3 py-2 ml-3"
              onClick={() => UpdateAppointmentOfferModal()}
            >
              Confirm
            </GreenColorButton>
          </Grid> :
            <Grid item lg={12} md={12} sm={12} xs={12} container justifyContent={"flex-end"}>
              <PrimeGrayBorderColorButton
                type="submit"
                className="px-5 py-2"
                onClick={() => CloseAppointmentOfferModal()}
              >
                Close
              </PrimeGrayBorderColorButton>
              <GreenColorButton
                type="submit"
                className="px-3 py-2 ml-3"
                onClick={() =>DownloadAppointmentLetters() }
              >
                Download Appointment Letter
              </GreenColorButton>
            </Grid>
        }
      />
      <CustomModal
        open={confomationModal}
        setOpen={CloseConfomationModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CiCircleQuestion color={"#12A59B"} size={100} />
          <p className="poppinsRegular Text-Prime-Black pt-3 text-center">Are you sure you want to update this candidate’s final appointment details?</p>
          <p className="poppinsLight Text-Prime-Gray pt-3 text-center">Ensure all details are accurate before update.</p>
          <Grid item container display={"flex"} justifyContent={"center"} sx={{ marginTop: "6%" }}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => CloseConfomationModal()}
            >
              No
            </PrimeGrayBorderColorButton>
            <DarkGreenColorButton
              type="submit"
              className="px-5 py-2 ml-2"
              onClick={() => UpdateConformed()}
            >
              Yes
            </DarkGreenColorButton>
          </Grid>
        </Grid>
        }
      />
    </Grid>
  );
};

export default FinalAppointmentDetails;
